import { GalleryList } from './gallery'

class SoldPhotographsList extends GalleryList {

    getEntityKey() {
        return 'photographer/sold_photographs'
    }
}

export const soldPhotographsList = new SoldPhotographsList('sold_photographs_default')
